import {Component, OnInit, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import {AbstractControl, FormArray, FormBuilder, FormControl, Validators} from '@angular/forms';
import {Attachment, IFaq} from '../../../../models/faq.model';
import {FaqService} from '../../../../services/faq.service';
import {environment} from "../../../../environments/environment";
import { Validation } from '../../error/error-messages/validator-messages';
import { Router } from '@angular/router';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  constructor(private fb: FormBuilder, private faqService: FaqService,
              private router: Router) { }

  faq: IFaq[] = [];
  faqTmp: IFaq[] = [];
  url_photo: string;

  typeFile = '';
  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  imageObject: Array<object> = [];
  imageObject1: Array<object> = [];
  index = 0;
  index1 = 0;
  newAttachments: Attachment[];
  currentAttachments: Attachment[];

  // @ts-ignore
  currentFaq: IFaq = [];

  /*
  -----------------------------         for all page attribute    --------------------------------
  */
  search: any;
  page = 1;
  perPage = 10;
  /*
  end for all page
   */
  sorted1 = false;

  // 👧🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥--------------- file input
  url: any;
  msg!: string;
  test = false;
  image: any;


  editForm = this.fb.group({
    question: new FormControl('', [ Validators.required]),
    response: new FormControl('', [ Validators.required]),
    category: new FormControl('', [ Validators.required]),
    attachments: this.fb.array([])
  });

  faqForm = this.fb.group({
    question: new FormControl('', [ Validation.requiredValidator("La question"),]),
    // response: new FormControl('', []),
    response: new FormControl('', [ Validation.requiredValidator("La reponse"),]),
    category: new FormControl('', [ Validation.requiredValidator("La catégorie"),]),
    attachments: this.fb.array([])
  });

  model = {
    response: ''
  };

  ngOnInit(): void {
    this.loadFaq();
    this.newAttachments = [];
    this.url_photo = environment.url_photo;
  }

  loadFaq = () => {
    this.faqService.getFaq()
      .subscribe((data: any) => {
        this.faq = data;
        //console.log("--------------------")
        //console.log(this.faq)
        this.faqTmp = data;
        this.faq.forEach(value => {
          value.attachments.forEach(value1 => {
            value1['index'] = this.index;
            this.index++;
            const img = {
              'image': this.url_photo + '/' + value1.path
            };
            this.imageObject.push(img);
          });
        });
        // console.log(this.faq);
      }, (err) => {
        // console.log('-----> err', err);
      });
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
  
  onEditFaq(id: any) {
    this.isAddEdit = false
    // @ts-ignore
    this.currentFaq = [];
    this.faqService.getidFaq(id).subscribe(rs => {
      this.currentFaq = rs;
      this.currentAttachments = this.currentFaq.attachments;
      // console.log("This currentAttachement")
      // console.log(this.currentFaq.attachments)
      this.currentAttachments.forEach(value => {
        value['index'] = this.index;
        this.index1++;
        const img = {
          'image': this.url_photo + '/' + value.path
        };
        this.imageObject1.push(img);
      });
      //  console.log("this.imageObject1");
      //  console.log(this.imageObject1);
      this.editForm = this.fb.group({
        id: new FormControl(this.currentFaq.id, [ ]),
        question: new FormControl(this.currentFaq.question, [ Validators.required]),
        response: new FormControl(this.currentFaq.response, [ Validators.required]),
        category: new FormControl(this.currentFaq.category, [ Validators.required]),
        attachments: this.fb.array(this.currentFaq.attachments, [])
        // attachments: this.fb.array(this.currentFaq.attachments.map(attachment => 
        //   this.fb.group({
        //     path: [ this.url_photo + '/' + attachment.path ],
        //     type: [attachment.type || 'image']
        //   })
        // ), [])

        // attachments: this.fb.array(
        //   this.currentFaq.attachments.map((attachment) =>
        //     this.fb.group({
        //       displayPath: [this.url_photo + '/' + attachment.path], // Pour affichage
        //       path: [''], // Champ de type file, vide au départ
        //       type: [attachment.type || 'image'],
        //     })
        //   )
        // ),

        // attachments: this.fb.array(
        //   this.currentFaq.attachments.map((attachment) =>
        //     this.fb.group({
        //       path: [attachment.path || '', Validators.required],
        //       type: [attachment.type || 'image', Validators.required],
        //     })
        //   )
        // ),
        
      });
      // console.log("this.editForm")
      // console.log(this.editForm)
      this.model.response = this.currentFaq.response;
    });
  }

  get attachments() {
    return this.faqForm.controls['attachments'] as FormArray;
  }

  get attachmentsEdit(): FormArray {
    return this.editForm.controls['attachments'] as FormArray;
  }
  onFaqFormSubmit() {
    // console.log(this.faqForm.value);
    const faq: IFaq = this.faqForm.value;
    faq.response = this.model.response;
    this.newAttachments = [];
    // console.log("~~~~~~~~~~~~~~~~~~~~~~~~");
    // console.log(faq);
    this.faqService.saveFaq(faq).subscribe(rs => {
      // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La question a été ajoutée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.close();
      this.reloadComponent();
      this.loadFaq();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez verifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  onEditFormSubmit() {
    const faq: IFaq = this.editForm.value;
    this.newAttachments.forEach(element => {
      faq.attachments.push(element);
    });
    faq.response = this.model.response;
    // console.log("~Edition~~~~~~~~~~~~~~~~~~~~~~~~");
    //console.log(faq.attachments);
    this.newAttachments = [];
    this.faqService.updateFaq(faq).subscribe(rs => {
      // console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'La question a été modifiée avec succés"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadFaq();
      this.reloadComponent()
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez vérifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  deleteFaq(id: any) {
    this.newAttachments = [];
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ce faq ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.faqService.deleteFaq(id).subscribe(
          rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Faq supprimé avec succés"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadFaq();
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        });
      }
    });
  }

  showLightbox(index) {
    this.selectedImageIndex = index;
    this.showFlag = true;
  }

  closeEventHandler() {
    this.showFlag = false;
    this.selectedImageIndex = -1;
    // @ts-ignore
    this.currentFaq = [];
  }

  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    // console.log(this.perPage);
  }

  // searchFilter($event: KeyboardEvent) {
  //   // console.log(this.search);
  //   this.faqService.getFaq().subscribe(data => {
  //     this.faq = data.content;
  //     this.faq = this.faq.filter(value =>
  //       value.question?.toLowerCase().includes(this.search) || value.question?.toUpperCase().includes(this.search) ||
  //       value.response?.toUpperCase().includes(this.search) ||  value.response?.toLowerCase().includes(this.search)
  //     );
  //   }, (err) => {
  //   });
  // }

  searchFilter(KeyboardEvent) {
    if (KeyboardEvent.target.value) {
      const searchValue = KeyboardEvent.target.value.toLowerCase().replace(/\s/g, '');
      this.faq = this.faqTmp.filter(value =>
        (value?.question?.toLowerCase().replace(/\s/g, '').indexOf(searchValue) !== -1) ||
        (value?.response?.toLowerCase().replace(/\s/g, '').indexOf(searchValue) !== -1) ||
        (value?.category?.toLowerCase().replace(/\s/g, '').indexOf(searchValue) !== -1)
      );
    } else {
      this.faq = this.faqTmp;
    }
  }


  /*
  end for all page
   */

  addAttachment() {
    const attachmentForm = this.fb.group({
      path: ['', Validators.required],
      type: ['image'],
    });
    // console.log("Avant push de this.attachmentsEdit")
    // console.log(this.attachments)
    this.attachments.push(attachmentForm);
    // console.log("Apres push de this.attachmentsEdit")
    // console.log(this.attachments)
  }

  isAddEdit: boolean = false
  addEditAttachment() {
    this.isAddEdit = true
    const attachmentForm = this.fb.group({
     // displayPath:  [''],
      path: ['', Validators.required],
      type: ['image'],
    });
    // console.log("Avant push de this.attachmentsEdit")
    // console.log(this.attachmentsEdit)
    this.attachmentsEdit.push(attachmentForm);
    // console.log("apres push de this.attachmentsEdit")
    // console.log(this.attachmentsEdit)
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  deleteAttachment(attachmentIndex: number) {
    this.attachments.removeAt(attachmentIndex);
    this.newAttachments.splice(attachmentIndex, 1);
  }

  deleteEditAttachment(attachmentIndex: number) {
    this.attachmentsEdit.removeAt(attachmentIndex);
    this.newAttachments.splice(attachmentIndex, 1);
  }


  selectTypeFile(value: string) {
    // console.log(value);
  }

// -----------------------------
  selectFile(event: any, i: number) {
    let urlPath: any;
    // Angular 11, for stricter type
    const mimeType = event.target.files[0].type;
    // console.log(event.target.files);
    const sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      this.msg = 'Selectionner une photo';
    }
    // console.log('size!!!!!');
    // console.log(sizeFile);
    if (sizeFile < 2000000) {
      // console.log(mimeType);

      if (mimeType === 'image/jpeg' || mimeType === 'image/jpg'  || mimeType === 'image/svg' || mimeType === 'image/svg+xml' || mimeType === 'image/png') {

        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = '';
          this.url = reader.result;
          const att: Attachment = this.attachments.controls[i].value;
          // console.log("aatttttttttttttttttt")
          // console.log(att)
          att.path = this.url;
          this.newAttachments.push(att);
          this.currentAttachments.push(att);
        };
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = 'Ce type de fichier n\'est pas pris en compte.';
          this.url = reader.result;
          this.test = false;
        };
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msg = 'La taille de l\'image est trop grande';
        this.url = reader.result;
        this.image = this.url;
        this.test = false;
        // console.log( this.url);
      };
    }
  }

  selectFileEdit(event: any, i: number) {
    let urlPath: any;
    // Angular 11, for stricter type
    const mimeType = event.target.files[0].type;
    // console.log(event.target.files);
    const sizeFile = event.target.files[0].size;
    if (!event.target.files[0] || event.target.files[0].length === 0) {
      this.msg = 'Selectionner une photo';
    }
    // console.log('size!!!!!');
    // console.log(sizeFile);
    if (sizeFile < 2000000) {
      // console.log(mimeType);
      // console.log("this.attachmentsEdit.at(i)")
      // console.log(this.attachmentsEdit.at(i))
      if (mimeType === 'image/jpeg' || mimeType === 'image/jpg'  || mimeType === 'image/svg' || mimeType === 'image/svg+xml' || mimeType === 'image/png') {

        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = '';
          this.url = reader.result;
          const att: Attachment = this.attachmentsEdit.controls[i].value;
          this.attachmentsEdit.at(i).get('path').setValue(reader.result as string);
          att.path = this.url;
          // console.log("aatttttttttttttttttt")
          // console.log(att)
          //this.newAttachments.push(att);
          // console.log("this.newAttachments")
          // console.log(this.newAttachments)
          this.currentAttachments.push(att);
        };
      } else {

        // this.msg = "Ce type de fichier n'est pas pris en compte.";
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
          this.msg = 'Ce type de fichier n\'est pas pris en compte.';
          this.url = reader.result;
          this.test = false;
        };
      }
    } else {
      // this.msg = "la taille de l'image est trop grande";
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.msg = 'La taille de l\'image est trop grande';
        this.url = reader.result;
        this.image = this.url;
        this.test = false;
        // console.log( this.url);
      };
    }
  }

  // selectFileEdit(event: any, i: number) {
  //   const file = event.target.files[0];
  
  //   if (!file) {
  //     this.msg = 'Aucun fichier sélectionné.';
  //     return;
  //   }
  
  //   const mimeType = file.type;
  //   const sizeFile = file.size;
  
  //   if (sizeFile >= 2000000) {
  //     this.msg = 'La taille de l\'image est trop grande.';
  //     return;
  //   }
  
  //   if (!['image/jpeg', 'image/jpg', 'image/png', 'image/svg', 'image/svg+xml'].includes(mimeType)) {
  //     this.msg = 'Ce type de fichier n\'est pas pris en charge.';
  //     return;
  //   }
  
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     const attachmentControl = this.attachmentsEdit.at(i);
  
  //     if (!attachmentControl) {
  //       console.error(`Attachment control at index ${i} is missing!`, this.attachmentsEdit.value);
  //       return;
  //     }
  //     console.log("Attachement avant")
  //     console.log(this.currentAttachments)
  //     // Mettez à jour le formulaire et l'aperçu
  //     attachmentControl.get('path').setValue(reader.result as string);
  //     this.msg = '';
  //     const att: Attachment = this.attachmentsEdit.controls[i].value;
  //     //att.path = this.url;
  //     this.currentAttachments.push(att);
  //     //this.newAttachments.push(att);
  //     console.log(`File at index ${i} updated successfully!`);

  //     console.log("Attachement apres push")
  //     console.log(this.currentAttachments)
  //   };
  
  //   reader.onerror = () => {
  //     this.msg = 'Erreur lors du chargement du fichier.';
  //     console.error('FileReader error:', reader.error);
  //   };
  
  //   reader.readAsDataURL(file);
  // }
  

  
  
  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.faq.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.faq.sort((a, b) => a.name < b.name ? 1 : a.name > b.name ? -1 : 0)
      this.sorted1 = false;
    }
  }


}
